/* global localStorage */
import Auth0Lock from 'auth0-lock'
import * as defaultConst from '../constants/default_constants'
import * as linkConst from '../constants/link_constants'
import { NotificationManager } from 'react-notifications'

export default class AuthService {
  constructor (clientId, domain) {
    const showVersion = ['loca', 'dev.', 'stg.'].indexOf((window.location.hostname).substring(0, 4)) >= 0
    // Configure Auth0
    this.lock = new Auth0Lock(clientId, domain, {
      auth: {
        redirect: false,
        redirectUrl: window.location.origin + '/',
        responseType: 'token',
        sso: true,
        params: {
          scope: 'openid email user_metadata' // this is SUPER IMPORTANT!! (affects content of token)
        }
      },
      avatar: null,
      theme: {
        logo: '/css/film-cargo.png',
        primaryColor: '#111111'
      },
      languageDictionary: {
        title: showVersion
          ? (window.location.hostname).substring(0, 3).toUpperCase().concat(' ') + linkConst.LINK_HOME_TITLE +
            ' v.' + defaultConst.LATEST_VERSION[0].concat(' ') + defaultConst.LATEST_VERSION[1]
          : linkConst.LINK_HOME_TITLE
      }
    })

    setInterval(() => {
      this.lock.checkSession({}, err => {
        if (err) {
          this.logout()
          return false
        }
      })
    }, defaultConst.AUTH0_TEST_INTERVAL * 60 * 1000)
  }

  login () {
    const self = this
    // Call the show method to display the widget.
    this.lock.show()
    return new Promise((resolve, reject) => {
      // Add callback for lock `authenticated` event
      this.lock.on('authenticated', (authResult) => {
        this.lock.getUserInfo(authResult.accessToken, function (error, profile) {
          self.lock.hide()
          if (error) {
            self.addMessage(error, 'error', 6000)
            return resolve(null)
          } else if (profile && profile.email_verified !== true) {
            reject('Unauthorized access: Email not verified!')
          } else {
            self.addMessage('Login was successful', 'success', 2000)
            // Saves the user and token
            self.setUserInfo(authResult.idToken, profile)
            resolve(authResult.idToken)
          }
        })
      })
    })
  }

  getProfile (token, requester) {
    return new Promise((resolve, reject) => {
      const timestamp = Math.round((new Date()).getTime() / 1000)
      const getRights = (profile) => requester.call(`/rights/?uid=${profile.email}`)
        .then((res) => {
          profile.rights = res.data
          resolve(profile)
        })
        .catch(reject)

      if (localStorage.getItem('cargo_user') &&
        ((timestamp - localStorage.getItem('id_token_timestamp')) < (defaultConst.AUTH0_TEST_INTERVAL * 2))
      ) {
        getRights(JSON.parse(localStorage.getItem('cargo_user')))
      } else {
        this.lock.checkSession({}, (err, authResult) => {
          if (err) {
            this.logout()
            return resolve(null)
          }
          this.lock.getUserInfo(authResult.accessToken, (error, fetchedProfile) => {
            if (error) {
              return resolve(null)
            }
            this.setUserInfo(authResult.idToken, fetchedProfile)
            const savedProfile = localStorage.getItem('cargo_user')
            if (!savedProfile) {
              return resolve(null)
            }
            const profile = JSON.parse(savedProfile)
            getRights(profile)
          })
        })
      }
    })
  }

  setUserInfo (idToken, user) {
    // Saves user token to localStorage
    localStorage.setItem('id_token', idToken)
    localStorage.setItem('id_token_timestamp', Math.round((new Date()).getTime() / 1000))
    localStorage.setItem('cargo_user', JSON.stringify(user))
  }

  getToken () {
    // Retrieves the user token from localStorage
    return localStorage.getItem('id_token')
  }

  logout () {
    // Clear user token and profile data from localStorage
    localStorage.removeItem('id_token')
    localStorage.removeItem('cargo_user')
    localStorage.removeItem('latest_version')

    // logout from auth0
    this.lock.logout()
    window.location.reload()
  }

  addMessage (text, type = 'info', timeout = 3000) {
    NotificationManager[type](text, type, timeout)
  }
}
